// TRICKY: TypeScript is broken and removes values from this as a const, when used in SOME places.
// Changing it to an enum works. 👻
export enum PropertyObjectNames {
  Object = "fpe_context_props",
  Command = "fpe_command_context_props",
  Animation = "animation_data.action.fpe_anim_context_props",
  FrameCommands = "animation_data.action.fpe_frame_commands_context_props",
  Scene = "fpe_scene_context_props",
}

export type PropertyObjectNamesType = keyof typeof PropertyObjectNames;
